import React, { ReactChild } from 'react'
import './styles.ts'
import { DolaThemes } from '../../styles/types'
import {
  Action,
  CheckboxWrapper,
  Clickable,
  Content,
  Icon,
  Main,
} from './styles'

export interface LineItemCheckBoxHelpers {
  disabled?: boolean
  name: string
  onCheck: () => void
  className?: string
  checked: boolean
}

export interface LineItemBaseProps {
  borderless?: boolean
  button?: ReactChild
  checkbox?: ReactChild
  onClick?: () => void
}

interface LineItemProps extends LineItemBaseProps {
  content: {
    line1?: ReactChild
    line2?: ReactChild
  }
  disabled?: boolean
  icon?: ReactChild
  theme?: DolaThemes
}

const LineItem: React.FC<LineItemProps> = ({
  disabled,
  icon,
  content: { line1, line2 },
  button,
  checkbox,
  onClick,
}) => {
  return (
    <div className="entity-line-item">
      <Content>
        {checkbox && (
          <CheckboxWrapper className="centralize">{checkbox}</CheckboxWrapper>
        )}
        <Clickable
          disabled={!!disabled}
          onClick={() => {
            if (!disabled && onClick) {
              onClick()
            }
          }}
        >
          <Main>
            {icon && <Icon className="entity-line-item__icon">{icon}</Icon>}
            <div>
              <div>
                <div>{line1}</div>
              </div>
              <div>
                <div>{line2}</div>
              </div>
            </div>
          </Main>
          <Action>{button}</Action>
        </Clickable>
      </Content>
    </div>
  )
}

export default LineItem
